import React, { Component } from 'react'
import { Upload, message } from 'antd'
import classnames from 'classnames'
import request from 'meinian-package/src/utils/request'

import './index.less'

const CDN_HOST = 'https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/'
const CDN_DIR = 'ins-selected/'
const GET_TOKEN_API = '/upload/get-oss-upload-token'
let token = {}
function unionid({ mime, customDir }) {
  return `${customDir || CDN_DIR + new Date().getTime()}_${Math.random().toString(32).substr(2, 10)}${mime || '.png'}`
}
const MAX_SIZE = 10// 10m

// https://github.com/ant-design/ant-design/issues/10122
export default class UploadImg extends Component {
  state = {}

  render() {
    const {
      setUrl,
      multiple = false, maxFileSize,
      onSuccess,
      onUploadProgress, onError, customDir, prevent
    } = this.props
    const maxSize = maxFileSize || MAX_SIZE
    const uploadHandle = {
      name: 'file',
      accept: '.png,.jpeg,.jpg',
      multiple,
      showUploadList: false,

      async customRequest({ file }) {
        if (prevent) return
        if (file.size / 1024 / 1024 > maxSize) {
          if (onError) {
            onError?.(`文件大小不能超过${maxSize}M`)
          } else {
            message.error(`文件大小不能超过${maxSize}M`)
          }
          return
        }
        const result = await request.get(GET_TOKEN_API, { params: { dir: customDir || CDN_DIR } })
        const res = result.sign
        token = {
          OSSAccessKeyId: res.accessid,
          signature: res.signature,
          key: res.key,
          policy: res.policy
        }
        const newRes = { host: res.host, token }
        const key = unionid({ customDir })
        try {
          await request.formdata(res.host, {
            ...newRes.token,
            success_action_status: 200,
            key,
            file
          }, e => onUploadProgress?.(e, key, file))
          setUrl?.(`${CDN_HOST + key}`, file.name) // 尽量使用onSuccess,命名相对规范
          onSuccess?.(`${CDN_HOST + key}`, file.name)
        } catch (error) {
          onError?.('上传失败')
        }
      },
    }
    return (
      <div className={classnames('upload-img', this.props.className)} style={this.props.style}>
        <Upload onSuccess={e => console.log('success', e)} beforeUpload={this.props.beforeUpload} {...uploadHandle}>{this.props.children}</Upload>
      </div>
    )
  }
}
